module.exports = __webpack_public_path__ + "img/greengrass2.412f20f7.jpg";